import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getAnnouncements, getMe, selectAnnouncements, selectMe } from "../redux/slices/generalSlice";
import { getDashboard, selectActiveSubscriptions, selectUserStatistics } from "../redux/slices/publicSlice";
import { formatDate } from "../utils/formatTime";
import Announcement from "../components/Announcement";
import { ThemeContext } from "../App";
import { Helmet } from "react-helmet-async";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "../assets/public/css/dashboard.css";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import { backendServerBaseURL } from "../utils/backendServerBaseURL";
import { deleteUserAccount } from "../redux/slices/adminSlice";
import CustomCircularProgress from "../components/CustomCircularProgress";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeSubscriptions = useSelector(selectActiveSubscriptions);
  const userStatistics = useSelector(selectUserStatistics);
  const me = useSelector(selectMe);
  const themeContextValue = useContext(ThemeContext);

  const [show, setShow] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleMoreClose = () => setShowMore(false);
  const handleMoreShow = () => setShowMore(true);

  const handleDelete = async () => {
    dispatch(deleteUserAccount({ userId: me?.id }));
  };

  const [doughnut, setDoughnut] = useState();

  const announcements = useSelector(selectAnnouncements);

  useEffect(() => {
    dispatch(getAnnouncements());
  }, []);

  useEffect(() => {
    dispatch(getDashboard());
    dispatch(getMe());
  }, []);

  useEffect(() => {
    const data = {
      labels: ["Remaining", "Used"],
      datasets: [
        {
          data: [
            userStatistics?.totalGBLeft?.toFixed(2),
            (userStatistics?.totalGBPurchased - userStatistics?.totalGBLeft)?.toFixed(2),
          ],
          backgroundColor: ["#00C9A7", "#377DFF", "#E8EAED"],
          borderWidth: 0,
          borderColor: "white",
        },
      ],
    };

    const options = {
      maintainAspectRatio: false,
      cutoutPercentage: 50,
      legend: {
        display: false,
      },
    };
    setDoughnut({
      data,
      options,
    });
  }, [userStatistics]);

  const formatToHrsAndMinutes = (duration) => {
    const totalMinutes = duration / 60;

    return Math.round(totalMinutes / 60) !== 0
      ? `${Math.round(totalMinutes / 60)} hours ${Math.round(totalMinutes % 60)} minutes`
      : `${Math.round(totalMinutes % 60)} minutes`;
  };

  return (
    <>
      <Helmet>
        <title>Dashboard - LightningProxies</title>
      </Helmet>
      {/* <Announcement /> */}
      <div class="page-body-wrapper">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6 col-xl-6">
            <div class="header-title text-start">
              <h1>Welcome {me?.username}</h1>
              <p>Welcome back, we're glad to have you.</p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <div class="active-balance-box mt-15">
              <div class="icon">
                <img src="/assets/images/icons/doller.svg" alt="Add Balance" class="img-fluid" />
              </div>
              <div class="d-flex flex-column mt-4 align-items-start">
                <h5>Active Balance</h5>
                <div className="d-flex w-100 flex-row justify-content-between mt-2 gap-3 m-lg-0">
                  <div>
                    <h4>${me?.balance ? Math.round(me?.balance * 100) / 100 : "0.00"}</h4>
                  </div>
                  <div>
                    <Link to="/topup" className="py-1">
                      Add Balance <i class="fa fa-angle-right ms-0"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <hr />
              <table>
                <tr>
                  <td className="text-start">Total Balance Spent</td>
                  <td>${(userStatistics?.totalAmountSpent || 0).toFixed(2)}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <div class="active-balance-box mt-15">
              <div class="icon">
                <img src="/assets/images/icons/cart.svg" alt="Add Balance" class="img-fluid" />
              </div>
              <div class="d-flex flex-column mt-4 align-items-start">
                <h5>Active Plans</h5>
                <div className="d-flex w-100 flex-row justify-content-between mt-2 gap-3 m-lg-0">
                  <div>
                    <h4 className="text-start">{activeSubscriptions?.length || 0}</h4>
                  </div>
                </div>
              </div>
              <hr />
              <table>
                <tr>
                  <td className="text-start">Total Purchased Plans</td>
                  <td>{userStatistics?.totalPlansPurchased || 0}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <div class="active-balance-box mt-15">
              <div class="d-flex">
                <div>
                  <div class="icon mb-4">
                    <img src="/assets/images/icons/server.svg" alt="Add Balance" class="img-fluid" />
                  </div>

                  <div class="d-flex flex-column mt-4 align-items-start">
                    <h5>Data Left</h5>
                    <div className="d-flex w-100 flex-row justify-content-between mt-2 gap-3 m-lg-0 pt-1">
                      <div>
                        <h4 className="text-start">
                          {(userStatistics?.totalGBLeft || 0).toFixed(2)}
                          GB
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div style={{ maxWidth: "8.4rem", maxHeight: "8.4rem" }}>
                    <CircularProgressbarWithChildren
                      strokeWidth={12}
                      value={userStatistics?.totalGBLeft ? userStatistics?.totalGBLeft?.toFixed(2) : 0}
                      minValue={0}
                      maxValue={userStatistics?.totalGBPurchased === 0 ? 1 : userStatistics?.totalGBPurchased}
                      styles={{
                        path: {
                          // Path color
                          stroke: `#1675FF`,
                          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                          strokeLinecap: "butt",
                          // Customize transition animation
                          transition: "stroke-dashoffset 0.5s ease 0s",
                          // Rotate the path
                          // transform: "rotate(0.25turn)",
                          // transformOrigin: "center center",
                        },
                        // Customize the circle behind the path, i.e. the "total progress"
                        trail: {
                          // Trail color
                          stroke: "rgba(22, 117, 255,0.1)",
                          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                          strokeLinecap: "round",
                          // Rotate the trail
                          // transform: "rotate(0.25turn)",
                          // transformOrigin: "center center",
                        },
                      }}
                    >
                      <div className="text-center">
                        <h1 className="fs-5 fw-bolder">
                          {userStatistics?.totalGBPurchased
                            ? userStatistics?.totalGBLeft !== userStatistics?.totalGBPurchased
                              ? ((userStatistics?.totalGBLeft / userStatistics?.totalGBPurchased) * 100).toFixed(0)
                              : "100"
                            : 0}
                          %
                        </h1>
                        <p className="fs-6" style={{ fontWeight: "500" }}>
                          Data Left
                        </p>
                      </div>
                    </CircularProgressbarWithChildren>
                  </div>
                  {/* <img
                    src="/assets/images/empty-circle.svg"
                    alt="Add Balance"
                    class="img-fluid d-light"
                  />
                  <img
                    src="/assets/images/dak-mode/empty-circle.svg"
                    alt="Add Balance"
                    class="img-fluid d-dark"
                  /> */}
                </div>
              </div>
              <hr className="mt-3" />
              <table>
                <tr className="text-nowrap">
                  <td className="text-start ">Total Data Purchased</td>
                  <td>{(userStatistics?.totalGBPurchased || 0).toFixed(2)} GB</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3">
            <div class="active-balance-box mt-15">
              <div class="d-flex">
                <div class="w-100 text-center">
                  <div class="icon user-avatar mx-auto mb-3">
                    <img src="/assets/images/icons/user.svg" alt="user" class="img-fluid" />
                  </div>

                  <h4 clas style={{ fontSize: "1.30438rem" }}>
                    {me?.username}
                  </h4>
                  <h5 style={{ fontSize: "0.91306rem" }}>{me?.id}</h5>
                </div>
              </div>
              <ul class="user-icon p-1 p-lg-0 pt-lg-1">
                <li>
                  <Link to="/my-profile">
                    <img src="/assets/images/icons/g-01.svg" alt="user" class="img-fluid" />
                  </Link>
                </li>
                <li>
                  <Link to="/my-profile">
                    <img src="/assets/images/icons/g-02.svg" alt="user" class=" d-light img-fluid" />
                    <img src="/assets/images/icons/g-02-dark.svg" alt="user" class="d-dark img-fluid" />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="row text-start">
          <div class="col-12">
            <div class="header-title mt-15">
            </div>
          </div>
        </div>
      </div>

      {/* read more */}
      <Modal centered keyboard={false} show={showMore} onHide={handleMoreClose} className="delete-modal">
        <Modal.Header closeButton>
          <Modal.Title className="fs-5"> {announcements?.filter((ann) => ann.name === "BannerTitle")[0]?.value}</Modal.Title>
        </Modal.Header>
        <Modal.Body className=" m-4 text-center fs-6">
          {" "}
          {announcements?.filter((ann) => ann.name === "BannerBody")[0]?.value}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <div className="d-flex w-100 align-items-center justify-content-between">
            <Link to={announcements?.filter((ann) => ann.name === "BannerLink")[0]?.value}>
              Read More
              <i className="fa fa-angle-right ms-2"></i>
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Dashboard;
